import React from 'react'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT } from '@xfers/design-system'
import StraitsXBreadcrumbReturnToHome from '~/components/StraitsXBreadcrumbReturnToHome'
import { WrappedComponentProperty } from '~/types/route'

export default function withStraitsXBreadcrumbReturnToHome(
  WrappedComponent: React.ComponentType<WrappedComponentProperty>
): React.ComponentType<WrappedComponentProperty> {
  return class extends React.Component {
    render() {
      return (
        <>
          <BreadcrumbContainer>
            <StraitsXBreadcrumbReturnToHome />
          </BreadcrumbContainer>

          <WrappedComponent />
        </>
      )
    }
  }
}

const BreadcrumbContainer = styled.div`
  margin: 16px 0 0 16px;
  ${DESKTOP_BREAKPOINT} {
    margin: 0 0 0 40px;
  }
`
